import { useAuth0 } from '@auth0/auth0-react';
import { useNavigate } from 'react-router-dom';
import { useEffect } from 'react';
import { AllowedAction, CalcType } from 'api';
import { useAuthorization } from '../../hooks/useAuthorization';
import { LoadingScreen } from '../../components/Common/LoadingScreen';
import { useOpportunityId } from '../../hooks/useOpportunityId';

export const OpportunityRedirect = () => {
	const navigate = useNavigate();
	const { isAuthenticated, loginWithRedirect } = useAuth0();
	const { allowedActions } = useAuthorization();

	useOpportunityId();

	useEffect(() => {
		if (!isAuthenticated) {
			loginWithRedirect({
				appState: {
					returnTo: `/offer`
				}
			});
		}
	}, [isAuthenticated, loginWithRedirect]);

	useEffect(() => {
		if (allowedActions.length > 0 && allowedActions.includes(AllowedAction.CreateOffer)) {
			navigate('/offer', {
				state: { calcType: CalcType.Standard }
			});
		}
	}, [allowedActions, navigate]);

	return <LoadingScreen />;
};
